import { isCallInitiator } from 'features/AccessRequests/utils/canBypassWaitingRoom';
import type { WaitingRoomJoinMode } from '../../constants/waitingRoomJoinMode';
import { isAdmittedVcsSession, isHasWaitingListId, isInRoom } from './session';

export type ResolveWaitingRoomUiStateParams = {
    mode: WaitingRoomJoinMode;
    roomName: string;
    isWaitingForApproval: boolean;
    isJoinRejected: boolean;
    isRequiresWaitingRoomRejoin: boolean;
};

export type WaitingRoomUiState = {
    isShowWaitingPage: boolean;
    isShouldPoll: boolean;
};

/**
 * Решает, показывать ли экран ожидания одобрения и нужен ли poll joinCallByLink*.
 * Инициатор звонка waiting room не видит.
 */
export const resolveWaitingRoomUiState = ({
    mode,
    roomName,
    isWaitingForApproval,
    isJoinRejected,
    isRequiresWaitingRoomRejoin,
}: ResolveWaitingRoomUiStateParams): WaitingRoomUiState => {
    const isNotAdmittedYet = !isAdmittedVcsSession();
    const isHasQueueTicket = isHasWaitingListId();

    // Активная заявка в waiting room — всегда показываем экран ожидания (даже если isCallInitiator ошибочно true).
    if (isHasQueueTicket && isNotAdmittedYet && !isJoinRejected) {
        const isShouldPoll = !isInRoom() && (isWaitingForApproval || isHasQueueTicket);
        return { isShowWaitingPage: true, isShouldPoll };
    }

    // Инициатор без активной заявки и без reject не видит экран ожидания.
    if (isCallInitiator(roomName) && !isHasQueueTicket && !isJoinRejected) {
        return { isShowWaitingPage: false, isShouldPoll: false };
    }

    const isShowWaitingPage =
        isWaitingForApproval ||
        isJoinRejected ||
        (isHasQueueTicket && isNotAdmittedYet) ||
        (mode === 'embedded' && isRequiresWaitingRoomRejoin && isNotAdmittedYet);

    const isShouldPoll =
        !isInRoom() &&
        !isJoinRejected &&
        (isWaitingForApproval || (isShowWaitingPage && (isHasQueueTicket || isRequiresWaitingRoomRejoin)));

    return { isShowWaitingPage, isShouldPoll };
};

/**
 * Waiting/reject UI со стикерами DotLottie (вместо логотипа бренда).
 * REACT_APP_IS_F — fallback для foxtrot-сборок, где в secrets ещё нет отдельного флага.
 */
export const isWaitingLottieLayout =
    process.env.REACT_APP_VCS_WAITING_LOTTIE_LAYOUT_ENABLED === 'true' || process.env.REACT_APP_IS_F === 'true';
